module.exports = __webpack_public_path__ + "img/main-logo.abaaff8b.png";